import { create } from 'zustand';
import type { Payout } from '@/types/payout'; // Adjust the import path if necessary

type PayoutCheckoutStep = 'summary' | 'payment' | 'review';

export type PayoutScheduleOption = 'asap' | 'scheduled';

interface PayoutCheckoutState {
  payout: Payout | null;
  currentStep: PayoutCheckoutStep;
  selectedPaymentMethodId: string | null;
  saveAsDefault: boolean;
  payoutScheduleOption: PayoutScheduleOption;
  scheduledPayoutDate: string | null;
  paymentIntentClientSecret: string | null;
  setPayout: (payout: Payout) => void;
  setCurrentStep: (step: PayoutCheckoutStep) => void;
  setSelectedPaymentMethodId: (id: string | null) => void;
  setSaveAsDefault: (save: boolean) => void;
  setPayoutScheduleOption: (option: PayoutScheduleOption) => void;
  setScheduledPayoutDate: (date: string | null) => void;
  setPaymentIntentClientSecret: (secret: string | null) => void;
  reset: () => void;
}

const initialState = {
  payout: null,
  currentStep: 'summary' as PayoutCheckoutStep,
  selectedPaymentMethodId: null,
  saveAsDefault: false,
  payoutScheduleOption: 'asap' as PayoutScheduleOption,
  scheduledPayoutDate: null,
  paymentIntentClientSecret: null,
};

export const usePayoutCheckoutStore = create<PayoutCheckoutState>((set) => ({
  ...initialState,
  setPayout: (payout) => set({ payout }),
  setCurrentStep: (step) => set({ currentStep: step }),
  setSelectedPaymentMethodId: (id) => set({ selectedPaymentMethodId: id }),
  setSaveAsDefault: (save) => set({ saveAsDefault: save }),
  setPayoutScheduleOption: (option) => set({ payoutScheduleOption: option }),
  setScheduledPayoutDate: (date) => set({ scheduledPayoutDate: date }),
  setPaymentIntentClientSecret: (secret) => set({ paymentIntentClientSecret: secret }),
  reset: () => set(initialState),
}));

export const usePayoutCheckoutData = () => {
  const {
    payout,
    currentStep,
    selectedPaymentMethodId,
    saveAsDefault,
    payoutScheduleOption,
    scheduledPayoutDate,
    paymentIntentClientSecret,
  } = usePayoutCheckoutStore();
  return {
    payout,
    currentStep,
    selectedPaymentMethodId,
    saveAsDefault,
    payoutScheduleOption,
    scheduledPayoutDate,
    paymentIntentClientSecret,
  };
};
